import { LockKeyhole } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import { LocalizedLink } from '@/components/LocalizedLink'
import { useOverlay } from './OverlayProvider'

export function Footer() {
  const { t } = useTranslation('common')
  const { open } = useOverlay()
  return <footer className="site-footer">
    <div className="footer-accent" aria-hidden="true" />
    <div className="shell-container footer-grid">
      <div className="footer-identity">
        <LocalizedLink to="home" className="brand-link" aria-label={t('aria.brandHome')}>
          <img src="/brand/esamed.png" width="230" height="100" alt={t('brand.name')} />
        </LocalizedLink>
        <p className="footer-tagline">{t('footer.tagline')}</p>
        <p className="footer-copyright">{t('footer.copyright', { year: new Date().getFullYear() })}</p>
      </div>

      <nav className="footer-navigation" aria-label={t('footer.navigation')}>
        <h2>{t('footer.navigation')}</h2>
        {(['solutions', 'about', 'news', 'certifications', 'careers'] as const).map((key) => (
          <LocalizedLink key={key} to={key}>{t(`nav.${key}`)}</LocalizedLink>
        ))}
      </nav>

      <div className="footer-contacts">
        <h2>{t('footer.contacts')}</h2>
        <LocalizedLink className="footer-contact-link" to="tel:+390490995400">{t('contact.phone')}</LocalizedLink>
        <LocalizedLink className="footer-contact-link" to="mailto:esamed@esamed.it">{t('contact.email')}</LocalizedLink>
        <LocalizedLink to="contacts">{t('nav.contacts')}</LocalizedLink>
      </div>

      <div className="footer-legal-column">
        <h2>{t('footer.legalNotes')}</h2>
        <div className="footer-registration">
          <span>{t('footer.vat')}</span>
        </div>
        <nav className="footer-legal-links" aria-label={t('footer.legalNotes')}>
          <LocalizedLink to="privacy">{t('footer.privacy')}</LocalizedLink>
          <button className="text-button" onClick={() => open('cookies')}>{t('cookie.preferencesTitle')}</button>
          <LocalizedLink to="reserved" className="footer-reserved-link" aria-label={t('nav.reserved')}>
            <LockKeyhole aria-hidden="true" />
          </LocalizedLink>
        </nav>
      </div>
    </div>
  </footer>
}
